import React from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../Components/Navbar/Navbar";
import ProductCard from "../Components/ProductCard/ProductCard";
import Footer from "../Components/Footer/Footer";
import { Box } from "@mui/material";
import CardImg from "../Assets/ham_and_cheese_hot_bake.png";
import useMetaTracking from "../hooks/useMetaTracking";

function HamAndCheeseHotBake() {
  useMetaTracking("ViewContent", {
    content_name: "Ham & Cheese Hot Bake",
    content_category: "Regular Menu",
    content_ids: ["ham_and_cheese_hot_bake"],
    content_type: "pastries",
    value: 3.00,
    currency: "USD",
  });

  return (
    <>
      <Helmet>
        <title>Ham & Cheese Hot Bake | Đông Hưng Viên Bakery</title>
        <meta
          name="description"
          content="Flaky, golden puff pastry stuffed with ham & creamy melted cheese."
        />
        <meta
          property="og:title"
          content="Ham & Cheese Hot Bake | Đông Hưng Viên Bakery"
        />
        <meta
          property="og:description"
          content="Flaky, golden puff pastry stuffed with ham & creamy melted cheese."
        />
      </Helmet>
      <Box className="product-page" sx={{ pt: 10, background: "#0f0f0f" }}>
        <Navbar />
        <ProductCard
          cardImg={CardImg}
          titleHead="Ham & Cheese Hot Bake"
          titleSubHead="$3.00 each"
          detailBody="Flaky, golden puff pastry stuffed with ham & creamy melted cheese. A warm, comforting bake perfect for breakfast, lunch or a tasty snack on-the-go."
          detailBodyBr="Contains: wheat, dairy, egg"
          detailBody3="Available now!"
          ProductCardBtn="View Full Regular Menu"
          btnLink="/regular-menu"
        />
        <Footer />
      </Box>
    </>
  );
}

export default HamAndCheeseHotBake;